//hook
import { useState, useEffect } from 'react';
import { useApi } from '../../hooks/useApi';
import { useRef } from "react";
import { UserConsumer } from '../../hooks/context/UserContext';

//translate
import { useTranslation } from 'react-i18next';
import i18n from '../../translate/i18n';

//api
import { GetReviewsApi } from '../../api/reviews/GetReviewsApi';
import { PostBookingApi } from '../../api/booking/PostBookingApi';
import { GetCitiesListApi } from '../../api/citiesAndRegions/GetCitiesListApi';
import { GetRegionsListApi } from '../../api/citiesAndRegions/GetRegionsListApi';



//css file
import styles from "./CarDetails.module.css"

//component
import ReviewCarCard from '../../component/reviewCarCard/ReviewCarCard';
import UserStateDilaog from '../UserStateDilaog';

//mui
import Dialog, { DialogProps } from '@mui/material/Dialog';
import Divider from '@mui/material/Divider';
import { CardMedia, FormControl, InputLabel, MenuItem, OutlinedInput, Select } from '@mui/material';
import CardActionArea from '@mui/material/CardActionArea';
import CircularProgress from '@mui/material/CircularProgress';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';


//mui icon
import StarIcon from '@mui/icons-material/Star';
import WeekendOutlinedIcon from '@mui/icons-material/WeekendOutlined';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import ReplayIcon from '@mui/icons-material/Replay';
import CloseIcon from '@mui/icons-material/Close';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import MergeTypeIcon from '@mui/icons-material/MergeType';

//type
import { carType, insurancesType } from '../../api/Cars/type/CarsType';
import { CarReview } from '../../api/reviews/type/reviewType';
import { bookingReqType } from '../../api/booking/type/BookingType';

//swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

//formik and yap
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

//mui date piker
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

//moment
import moment from 'moment';

//image
import cash from "../../assets/payments/chash.png"
import online from "../../assets/payments/online.jpg"
import TimeAndHourBooking from '../../component/TimeAndHourBooking';
import { formatDateTimeUTC } from '../../utils/formatDateTime';

const storageURL = process.env.REACT_APP_STORAGE_BASE_URL;
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: (theme.vars ?? theme).palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));


interface bestCarDetailsProps {
    selectedCar: carType | null,
    setSelectedCar: (selectedCar: carType | null) => void
    openCarDetails: {open:boolean,scrollType: DialogProps['scroll'];},
    setOpenCarDetails: (value: {open:boolean,scrollType: DialogProps['scroll']}) => void
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const CarDetails = ({selectedCar, setSelectedCar, openCarDetails, setOpenCarDetails,}:bestCarDetailsProps) => {
    const {t} = useTranslation()
    let {theme, userData} = UserConsumer()
    let [reviewsDate, setReviewsData] = useState<CarReview[]>([]);
    const [page, setPage] = useState<number>(1);
    const reviewsPerPage = 3;
    const [lastPage, setLastPage] = useState<number>(1);
    const loaderRef = useRef<HTMLDivElement | null>(null);
    const [initialLoading, setInitialLoading] = useState<boolean>(true);
    const [showAllReviews, setShowAllReviews] = useState<boolean>(false);
    const [showBookNow, setShowBookNow] = useState<boolean>(false);
    const [cities, setCities] = useState<{id: number, name: string}[]>([]);
    const [selectedCity, setSelectedCity] = useState<{Citylocation_in: number | 1, Citylocation_out: number | 1}>({Citylocation_in: 1, Citylocation_out: 1});
    const [regionsLocation_in, setRegionsLocation_in] = useState<{id: number, name: string}[]>([]);
    const [loadingRegionIn, setLoadingRegionIn] = useState(false);
    const [regionsLocation_out, setRegionsLocation_out] = useState<{id: number, name: string}[]>([]);
    const [loadingRegionOut, setLoadingRegionOut] = useState(false);
    let [userStateDilaogDilaog, setUserStateDilaogDilaog] = useState<{open:boolean, message:string}>({
        open: false,
        message: "",
    });

    const {
        loading: reviewsLoading,
        error: reviewsError,
        HandlerApi: getReviews
    } = useApi(GetReviewsApi, "GET");
    const {
        loading: citiesLoading,
        error: citiesError,
        HandlerApi: getcities
    } = useApi(GetCitiesListApi, "GET");
    const {
        loading: regionsLoading,
        error: regionsError,
        HandlerApi: getRegions
    } = useApi(GetRegionsListApi, "GET");
    const {
        loading: bookingLoading,
        error: bookingError,
        HandlerApi: postBooking
    } = useApi(PostBookingApi, "Post");

    const SignupSchema = Yup.object().shape({
        check_in_at: Yup.mixed()
            .required(t("check-in_date_is_required"))
            .test(
            "is-valid-date",
            "Invalid date",
            value => moment(value, "YYYY-MM-DD HH:mm:ss").isValid()),
        check_out_at: Yup.mixed()
            .required(t("check-out_date_is_required"))
            .test(
            "is-valid-date",
            "Invalid date",
            value => moment(value, "YYYY-MM-DD HH:mm:ss").isValid()
            ),
        region_name_location_in: Yup.number().required(t("region_name_location_in_required")),      
        region_name_location_out: Yup.number().required(t("region_name_location_out_required")),      
        payment_type: Yup.string().required(t("payment_type_required")),
        insurance_id: Yup.number().when([], {
        is: () => selectedCar?.insurances.length !== 0,
        then: (schema) => schema.required(t("insurance_type_required")),
        otherwise: (schema) => schema.notRequired(),
        }),
    });

    useEffect(() => {
    if (!selectedCar) {
        return
    }
    else {
        const fetchData = async (page: number) => {
            if(!showAllReviews) {
            const resultReviews = await getReviews(selectedCar?.id, `filters[page]=${page}&filters[per_page]=${reviewsPerPage}`);
            setReviewsData(resultReviews.data.data);
            }
            else {
                const resultReviews = await getReviews(selectedCar?.id, `filters[page]=${page}&filters[per_page]=${7}`);
                setLastPage(resultReviews.data.last_page);
                setReviewsData((prev: any) => {
                    const newCars = resultReviews.data.data;
                    const filteredPrev = prev.filter((car:any) => !newCars.some((element:any) => element.id === car.id));
                    const combined = [...filteredPrev, ...newCars];
                    return combined;
                });
                if (page === 1) setInitialLoading(false);
            }
        };
        if(!showAllReviews) {
            fetchData(page);
        }
        else {
            if (page <= lastPage) {
                fetchData(page);
            }
        }
    }
    }, [showAllReviews, page]);

    useEffect(() => {
    if (!loaderRef.current) {
        return;
    }
    else {
        // It watches an element and tells you:“Is this element visible on the screen right now?”
        const observer = new IntersectionObserver((entries) => {
            const firstEntry = entries[0];
            if (firstEntry.isIntersecting && !reviewsLoading && page < lastPage) {
            setPage((prev) => prev + 1);
            }
        });
        //tells the Intersection Observer:“Watch this element”
        observer.observe(loaderRef.current);
    }
    }, [reviewsLoading]);
    useEffect(() => {
        if(!showBookNow) {
            return
        }
        const fetchData = async () => {
            let citiesResult = await getcities();
            setCities(citiesResult.data);
            setLoadingRegionIn(true);
            let regionsResult = await getRegions(selectedCity.Citylocation_in);
            setRegionsLocation_in(regionsResult.data);
            setLoadingRegionIn(false);
            setLoadingRegionOut(true);
            regionsResult = await getRegions(selectedCity.Citylocation_out);
            setRegionsLocation_out(regionsResult.data);
            setLoadingRegionOut(false);
        }
        fetchData();
    },[showBookNow])

    //start functions

    const handleSubmit = async (values: any)=> {
        if(!selectedCar) {
            return
        }
        else {
            const cityIn = (cities as any).find((c: any) => c.id === Number(values.city_name_location_in));
            const regionIn = (regionsLocation_in as any).find((r: any) => r.id === Number(values.region_name_location_in));
            const cityOut = (cities as any).find((c: any) => c.id === Number(values.city_name_location_out));
            const regionOut = (regionsLocation_out as any).find((r: any) => r.id === Number(values.region_name_location_out));
            const payload :bookingReqType  = {
            car_id: values.car_id,
            check_in_at: values.check_in_at,
            check_out_at: values.check_out_at,
            location_in: `${cityIn?.name}-${regionIn?.name}`,
            location_out: `${cityOut?.name}-${regionOut?.name}`,
            with_driver: values.with_driver,
            payment_type: values.payment_type,
            ...(selectedCar?.insurances?.length !== 0 ? {insurance_id: values.insurance_id} : null)
            };
            let result = await postBooking(payload);
            if(result.data) {
                setOpenCarDetails({open:false, scrollType: "paper"});
                setShowBookNow(false)
            }
        }
    }

    //start functions
    
    return (
        <Dialog
        open={openCarDetails.open}
        onClose={()=>{
            setOpenCarDetails({open:false, scrollType: "paper"}); 
            setSelectedCar(null);
            setShowAllReviews(false);
            setSelectedCity({Citylocation_in: 1, Citylocation_out: 1})
        }}
        scroll={openCarDetails.scrollType}
        maxWidth="sm"
        fullWidth
        >
            <DialogContent className="!overflow-x-hidden !h-[700px] !p-0 relative" dividers={openCarDetails.scrollType === 'paper'}>
                {showAllReviews === false && showBookNow === false
                ?
                    <div>
                        <div className={`flex justify-end ${i18n.language === "en" ? "ltr left-2" : "rtl right-2"} !top-2 !absolute z-10`}>
                            <IconButton
                            className={`${theme === "client" ? selectedCar?.fuel_type === "electric" ? "!bg-electricColor" : "!bg-customerColor" : "!bg-paretnerColor" } !rounded-md max-sm:!w-[30px] max-sm:!h-[30px]`}
                            onClick={() => {
                                setOpenCarDetails({ open: false, scrollType: 'paper' });
                                setSelectedCar(null);
                                setShowAllReviews(false)
                                setSelectedCity({Citylocation_in: 1, Citylocation_out: 1})
                            }}
                            size="large"
                            >
                                <CloseIcon className='!text-white'/>
                            </IconButton>
                        </div>
                        <div>
                            <div>
                                <CardActionArea className={` ${i18n.language === "en" ? `ltrSwiper ${styles.ltrSwiper}` : `rtlSwiper ${styles.rtlSwiper}`}`}>
                                    <Swiper
                                    key={i18n.language}
                                    dir={i18n.language === "ar" ? "rtl" : "ltr"}
                                    loop={true}
                                    spaceBetween={30}
                                    navigation
                                    pagination={{ clickable: true }}
                                    modules={[Navigation, Pagination]}
                                    className={`carCardDetailsSwiper ${styles.carCardDetailsSwiper} ${selectedCar?.fuel_type === "electric" ? 'electricSwiper' : ''}`}
                                >
                                    {selectedCar?.primary_images.map((img, index) => (
                                    <SwiperSlide 
                                    className="
                                    !flex 
                                    justify-center 
                                    items-center 
                                    sm:!h-[300px] max-sm:!h-[200px]
                                    "
                                    key={index}>
                                        <CardMedia
                                        component="img"
                                        src={`${storageURL}/${img.url}`}
                                        className='!h-full'
                                        alt="no_photo"
                                        />
                                    </SwiperSlide>
                                    ))}
                                    </Swiper>
                                </CardActionArea>
                            </div>
                            <div className="mt-3 sm:p-5 max-sm:p-2">
                                <div className='flex justify-between items-center'>
                                    <p className={`brandCarDetails sm:text-3xl ${styles.brandCarDetails} font-[600]`}>{selectedCar?.brand.name} - {selectedCar?.model?.name}</p>
                                    <div className='flex flex-col items-center text-[#7F7F7F]'>
                                        <div className="flex items-center gap-2 mt-2">
                                            <StarIcon  className="!text-[#FF8F3A]"/>
                                            <p className='max-sm:text-[11px]'>{selectedCar?.avg_rate}</p>
                                        </div>
                                        <div className='mt-2 max-sm:text-[11px]'>
                                            <p>{`(${(selectedCar?.reviews_count ?? 0) > 50 ? `+${selectedCar?.reviews_count}` : selectedCar?.reviews_count} ${t("reviews")})`}</p>
                                        </div>
                                    </div>
                                </div>
                                <Divider className='!m-3'/>
                                <div className='mt-7'>
                                    <p className='text-darkColor font-[800] sm:text-xl max-sm:text-sm max-sm:mb-2'>{t("car_features")}</p>
                                    <div className='flex justify-between gap-3 mt-3'>
                                        <div className='w-[117px] p-2 rounded-lg bg-[#EDEDED]'>
                                            <div className='w-fit p-[7px] bg-white rounded-full'>
                                                <WeekendOutlinedIcon className='text-[#7F7F7F]'/>
                                            </div>
                                            <div className='mt-3'>
                                                <p className='text-[#7F7F7F] front-[600] text-[12px]'>{t("capacity")}</p>
                                                <p className='text-[14px] font-[600] text-black mt-2'>{selectedCar?.seating_capacity} {t("seats")}</p>
                                            </div>
                                        </div>
                                        <div className='w-[117px] p-2 rounded-lg bg-[#EDEDED]'>
                                            <div className='w-fit p-[7px] bg-white rounded-full'>
                                                <ColorLensIcon className='text-[#7F7F7F]'/>
                                            </div>
                                            <div className='mt-3'>
                                                <p className='text-[#7F7F7F] front-[600] text-[12px]'>{t("color")}</p>
                                                <p className='text-[14px] font-[600] text-black mt-2'>{selectedCar?.color}</p>
                                            </div>
                                        </div>
                                        <div className='w-[117px] p-2 rounded-lg bg-[#EDEDED]'>
                                            <div className='w-fit p-[7px] bg-white rounded-full'>
                                                <FlashOnIcon className='text-[#7F7F7F]'/>
                                            </div>
                                            <div className='mt-3'>
                                                <p className='text-[#7F7F7F] front-[600] text-[12px]'>{t("engine_type")}</p>
                                                <p className='text-[14px] font-[600] text-black mt-2'>{t(`${selectedCar?.fuel_type}`)}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='flex justify-between gap-3 mt-3'>
                                        <div className='w-[117px] p-2 rounded-lg bg-[#EDEDED]'>
                                            <div className='w-fit p-[7px] bg-white rounded-full'>
                                                <AttachMoneyIcon className='text-[#7F7F7F]'/>
                                            </div>
                                            <div className='mt-3'>
                                                <p className='text-[#7F7F7F] front-[600] text-[12px]'>{t("price_day")}</p>
                                                <p className='text-[14px] font-[600] text-black mt-2'>{t(`${selectedCar?.daily_price || "not_available"}`)}</p>
                                            </div>
                                        </div>
                                        <div className='w-[117px] p-2 rounded-lg bg-[#EDEDED]'>
                                            <div className='w-fit p-[7px] bg-white rounded-full'>
                                                <AttachMoneyIcon className='text-[#7F7F7F]'/>
                                            </div>
                                            <div className='mt-3'>
                                                <p className='text-[#7F7F7F] front-[600] text-[12px]'>{t("price_weekly")}</p>
                                                <p className={`${selectedCar?.weekly_price ? "text-[14px]" : "text-[10px]"} font-[600] text-black mt-2`}>{t(`${selectedCar?.weekly_price || "not_available"}`)}</p>
                                            </div>
                                        </div>
                                        <div className='w-[117px] p-2 rounded-lg bg-[#EDEDED]'>
                                            <div className='w-fit p-[7px] bg-white rounded-full'>
                                                <AttachMoneyIcon className='text-[#7F7F7F]'/>
                                            </div>
                                            <div className='mt-3'>
                                                <p className='text-[#7F7F7F] front-[600] text-[12px]'>{t("price_monthly")}</p>
                                                <p className={`${selectedCar?.weekly_price ? "text-[14px]" : "text-[10px]"} font-[600] text-black mt-2`}>{t(`${selectedCar?.monthly_price || "not_available"}`)}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='mt-10'>
                                    <div className='flex justify-between'>
                                        <h1 className='text-darkColor font-[800] sm:text-xl max-sm:text-sm max-sm:mb-2'>{t("reviews")}</h1>
                                        <div className='flex gap-2 cursor-pointer' onClick={()=>{setShowAllReviews(true); setReviewsData([])}}>
                                            <p className='max-sm:text-sm'>{t("view_all")}</p>
                                            <p>{i18n.language === "en" ? <ArrowForwardIcon/> : <ArrowBackOutlinedIcon/>}</p>
                                        </div>
                                    </div>
                                    <div className='mt-5'>
                                    {reviewsLoading
                                    ? 
                                    <div className='flex justify-center'>
                                        <CircularProgress/>
                                    </div>
                                    :
                                    <div>
                                        {reviewsError
                                        ?
                                        <div className='cursor-pointer flex justify-center'>
                                            <ReplayIcon onClick={()=>getReviews(selectedCar?.id || 0, `filters[page]=${page}&filters[per_page]=${7}`)} className='!text-[40px]'/>
                                        </div>
                                        :
                                        <div>
                                            <CardActionArea>
                                                <Swiper
                                                breakpoints={{
                                                    0: { slidesPerView: 1.2 },
                                                    640: { slidesPerView: 1.5 },
                                                }}
                                                key={i18n.language}
                                                dir={i18n.language === "ar" ? "rtl" : "ltr"}
                                                spaceBetween={20}
                                                grabCursor={true}
                                                navigation
                                                pagination={{ clickable: true }}
                                                modules={[Navigation, Pagination]}
                                                className={`carCardSwiper ${styles.carCardSwiper}`}
                                                >
                                                    {
                                                    reviewsDate?.length !== 0
                                                    ?
                                                    <>
                                                    {
                                                    reviewsDate.map((element, index) => (
                                                        <SwiperSlide 
                                                        key={index}
                                                        >
                                                            <div className='rounded-[15px] p-3 border-[1px] border-solid border-darkColor'>
                                                                <ReviewCarCard element={element}/>
                                                            </div>
                                                        </SwiperSlide>
                                                        ))
                                                    }
                                                    </>
                                                    :<p className='flex justify-center items-center'>{t("no_reviews_found")}</p>
                                                    }
                                                </Swiper>
                                            </CardActionArea> 
                                        </div>
                                        }
                                    </div>
                                    }
                                    </div>
                                </div>
                                <div>
                                    <h1 className='text-darkColor font-[800] sm:text-xl sm:mb-2 max-sm:text-sm max-sm:mb-2'>{t("offers")}</h1>
                                    {
                                        selectedCar?.offers
                                        ?
                                            selectedCar?.offers?.length !== 0
                                                ?
                                                    <div className='mt-5'>
                                                        {
                                                            selectedCar?.offers?.map((element, index) => (
                                                                <div key={index} className="bg-[#c1c3c74a] shadow-xl rounded-lg p-3 flex flex-col gap-3 mb-5">
                                                                    <div className='flex justify-between gap-3'>
                                                                        <div>
                                                                            <p>{t("price")}</p>
                                                                            <p>{element.price}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className='flex justify-between gap-3'>
                                                                        <TimeAndHourBooking
                                                                        title={t("start_date")}
                                                                        value={`${formatDateTimeUTC(element.start_date || "").date}`}
                                                                        icon={<CalendarTodayIcon/>}
                                                                        type = {selectedCar?.fuel_type}
                                                                        /> 
                                                                        <div className="w-[40%]">
                                                                            <TimeAndHourBooking
                                                                            title={t("end_date")}
                                                                            value={`${formatDateTimeUTC(element.end_date || "").date}`}
                                                                            icon={<CalendarMonthIcon/>}
                                                                            type = {selectedCar?.fuel_type}
                                                                            /> 
                                                                        </div>
                                                                    </div>
                                                                    <div className='flex justify-between gap-3'>
                                                                        <TimeAndHourBooking
                                                                        title={t("start_time")}
                                                                        value={`${formatDateTimeUTC(element.start_date|| "").time}`}
                                                                        icon={<QueryBuilderIcon/>}
                                                                        type = {selectedCar?.fuel_type}
                                                                        /> 
                                                                        <div className="w-[40%]">
                                                                            <TimeAndHourBooking
                                                                            title={t("end_time")}
                                                                            value={`${formatDateTimeUTC(element.end_date || "").time}`}
                                                                            icon={<WatchLaterIcon/>}
                                                                            type = {selectedCar?.fuel_type}
                                                                            /> 
                                                                        </div> 
                                                                    </div>
                                                                    <div className='flex justify-between gap-1'>
                                                                        <TimeAndHourBooking
                                                                        title={t("period_unit")}
                                                                        value={t(element.period_unit)}
                                                                        icon={<MergeTypeIcon/>}
                                                                        type = {selectedCar?.fuel_type}
                                                                        />  
                                                                        <div className="w-[40%]">
                                                                            <TimeAndHourBooking
                                                                            title={t("period_count")}
                                                                            value={element.period_count}
                                                                            icon={<MergeTypeIcon/>}
                                                                            type = {selectedCar?.fuel_type}
                                                                            /> 
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                :   
                                                    <p className='flex justify-center items-center'>{t("no_offers_found")}</p>
                                        :
                                            <></>
                                    }
                                </div>
                                {localStorage.getItem("token") 
                                ? 
                                <div className='flex justify-center mt-5'>
                                    <Button onClick={()=>{
                                        userData?.is_verified === 1 ? setShowBookNow(true) : setUserStateDilaogDilaog({open: true, message: t("your_account_is_not_verified_go_to_profile")})
                                    }} className={`${theme === "client" ? selectedCar?.fuel_type === "electric" ? "!bg-electricColor" : "!bg-customerColor" : "!bg-paretnerColor" } !w-[390px] sm:!h-[62px] max-sm:!h-[40px] !rounded-[62px] !text-white !capitalize`}>
                                        {t("book_now")}
                                    </Button>
                                </div>
                                : <></>
                                }
                            </div>
                        </div>
                    </div>
                : showAllReviews
                    ?
                        <div className='p-5'>
                            <div className="flex items-center gap-2 mb-3 cursor-pointer" 
                            onClick={() => {
                                setShowAllReviews(false); 
                                setPage(1); 
                                setInitialLoading(true)}}>
                                <p>{i18n.language === "en" ? <ArrowBackOutlinedIcon /> : <ArrowForwardIcon />}</p>
                                <p className='text-sm'>{t("back")}</p>
                            </div>
                            <div className='mt-5'>
                            {initialLoading
                            ? 
                            <div className='flex justify-center'>
                                <CircularProgress/>
                            </div>
                            :
                            <div>
                                {reviewsError
                                ?
                                <div className='cursor-pointer flex justify-center'>
                                    <ReplayIcon onClick={()=>{
                                        setPage(1)
                                        setReviewsData([])
                                        getReviews(selectedCar?.id || 0, `filters[page]=${page}&filters[per_page]=${7}`)
                                    }} className='!text-[40px]'/>
                                </div>
                                :
                                reviewsDate.length !== 0
                                ?
                                <>
                                    {
                                    reviewsDate.map((element, index) => (
                                    <div key={index}>
                                        <div className='rounded-[15px] mb-3 p-3 border-[1px] border-solid border-darkColor cursor-pointer'>
                                        <ReviewCarCard element={element}/>
                                        </div>
                                    </div>
                                    ))}
                                    <div ref={loaderRef} style={{ height: "10px"}} />
                                    {reviewsLoading && (
                                        <div className="flex justify-center mt-4">
                                        <CircularProgress size={32}/>
                                        </div>
                                    )}
                                </>
                                :<p className='flex justify-center items-center'>{t("no_reviews_found")}</p>
                                }
                            </div>
                            }
                            </div>
                        </div>
                    :
                        <div className='p-5'>
                            <div className="flex items-center gap-2 mb-3 cursor-pointer" 
                            onClick={() => {
                                setShowBookNow(false);
                                setCities([]);
                                setRegionsLocation_in([]);
                                setRegionsLocation_out([]);
                                setLoadingRegionIn(false);
                                setLoadingRegionOut(false);
                                }}>
                                <p>{i18n.language === "en" ? <ArrowBackOutlinedIcon /> : <ArrowForwardIcon />}</p>
                                <p className='text-sm'>{t("back")}</p>
                            </div>
                            <div>
                                <Formik
                                enableReinitialize
                                initialValues={{
                                    car_id: selectedCar?.id,
                                    check_in_at: null,
                                    check_out_at: null,
                                    city_name_location_in: 1, 
                                    region_name_location_in: 1,
                                    city_name_location_out: 1,
                                    region_name_location_out: 1,
                                    with_driver:false,
                                    payment_type: "",
                                    insurance_id: null
                                }}
                                validationSchema={SignupSchema}
                                onSubmit={(values)=>handleSubmit(values)}
                                >
                            {({ values,touched, errors,setFieldValue, setFieldTouched}) => (
                                <Form>
                                    <div className='mt-2 flex flex-col gap-5'>
                                        <div className="flex max-sm:flex-col gap-2">
                                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                                <DateTimePicker
                                                label={t("check_in")}
                                                format="YYYY-MM-DD HH:mm:ss"
                                                minDateTime={moment()}    
                                                closeOnSelect={false}
                                                value={values.check_in_at ? moment(values.check_in_at, "YYYY-MM-DD HH:mm:ss") : null}
                                                onChange={(value) => {
                                                    setFieldValue("check_in_at", value ? value.format("YYYY-MM-DD HH:mm:ss") : null);
                                                }}
                                                onClose={() => {
                                                    setFieldTouched("check_in_at", true);
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        helperText: values.check_in_at === null && touched.check_in_at && errors.check_in_at ? errors.check_in_at : null,
                                                        error: values.check_in_at === null && touched.check_in_at && Boolean(errors.check_in_at),
                                                        className: "w-full"
                                                    }
                                                }}
                                                />
                                            </LocalizationProvider>
                                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                                <DateTimePicker
                                                label={t("check_out")}
                                                format="YYYY-MM-DD HH:mm:ss"
                                                minDateTime={moment()}
                                                closeOnSelect={false}
                                                value={values.check_out_at ? moment(values.check_out_at, "YYYY-MM-DD HH:mm:ss") : null}
                                                onChange={(value) => {
                                                    setFieldValue("check_out_at", value ? value.format("YYYY-MM-DD HH:mm:ss") : null);
                                                }}
                                                onClose={() => {
                                                    setFieldTouched("check_out_at", true);
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        helperText: values.check_out_at === null && touched.check_out_at && errors.check_out_at ? errors.check_out_at : null,
                                                        error: values.check_out_at === null && touched.check_out_at && Boolean(errors.check_out_at),
                                                        className: "w-full"
                                                    }
                                                }}
                                                />
                                            </LocalizationProvider>
                                        </div>
                                        <div>
                                            <p className='font-[600] mb-2'>{t("location_in")}</p>
                                            <div className='flex max-sm:flex-col gap-2'>
                                                <FormControl className='sm:!w-1/2 !w-full' error={touched.city_name_location_in && Boolean(errors.city_name_location_in)}>
                                                    <InputLabel>{t("city_name")}</InputLabel>
                                                    <Select
                                                    input={<OutlinedInput label={t("city_name")} />}
                                                    MenuProps={MenuProps}
                                                    value={values.city_name_location_in}
                                                    renderValue={(selected) => {
                                                        if (citiesLoading) {
                                                            return (
                                                            <div className="flex items-center gap-2">
                                                                <CircularProgress size={18} />
                                                            </div>
                                                            )
                                                        }
                                                        else {
                                                            const city = (cities as any).find((c: any) => c.id === Number(selected));
                                                            return (
                                                            <div className="flex items-center gap-2">
                                                                <span>{city?.name}</span>
                                                            </div>
                                                            );
                                                        }
                                                    }}
                                                    onChange={async (e) => {
                                                        setSelectedCity({...selectedCity,Citylocation_in:Number(e.target.value)})
                                                        setLoadingRegionIn(true);
                                                        const result = await getRegions(Number(e.target.value));
                                                        setRegionsLocation_in(result.data);
                                                        setFieldValue("city_name_location_in",e.target.value)
                                                        setFieldValue("region_name_location_in",null)
                                                        setLoadingRegionIn(false);
                                                    }}
                                                    >
                                                        {
                                                            cities.map((item: any, index: number) => (
                                                                <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                                                            ))
                                                        }
                                                    </Select>
                                                    {touched.city_name_location_in && errors.city_name_location_in && (
                                                        <p className="text-red-500 text-xs mt-1">
                                                            {errors.city_name_location_in as string}
                                                        </p>
                                                    )}
                                                </FormControl>
                                                {
                                                    selectedCity.Citylocation_in 
                                                    ?
                                                        <FormControl className='sm:!w-1/2 !w-full' error={touched.region_name_location_in && Boolean(errors.region_name_location_in)}>
                                                            <InputLabel>{t("region_name")}</InputLabel>
                                                            <Select
                                                            input={<OutlinedInput label={t("region_name")} />}
                                                            MenuProps={MenuProps}
                                                            value={values.region_name_location_in}
                                                            renderValue={(selected) => {
                                                                if (loadingRegionIn) {
                                                                    return (
                                                                    <div className="flex items-center gap-2">
                                                                        <CircularProgress size={18} />
                                                                    </div>
                                                                    )
                                                                }
                                                                else {
                                                                    const region = (regionsLocation_in as any).find((c: any) => c.id === Number(selected));
                                                                    return (
                                                                        <div className="flex items-center gap-2">
                                                                            <span>{region?.name}</span>
                                                                        </div>
                                                                    );
                                                                }
                                                            }}
                                                            onChange={(e) => {setFieldValue("region_name_location_in",e.target.value)}}
                                                            >
                                                                {regionsLocation_in.map((item: any, index: number) => (
                                                                    <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                                                                ))}
                                                            </Select>
                                                            {touched.region_name_location_in && errors.region_name_location_in && (
                                                                <p className="text-red-500 text-xs mt-1">
                                                                {errors.region_name_location_in as string}
                                                                </p>
                                                            )}
                                                        </FormControl>
                                                    :   null 
                                                }
                                            </div>
                                        </div>
                                        <div>
                                            <p className='font-[600] mb-2'>{t("location_out")}</p>
                                            <div className='flex max-sm:flex-col gap-2'>
                                                <FormControl className='sm:!w-1/2 !w-full' error={touched.city_name_location_out && Boolean(errors.city_name_location_out)}>
                                                    <InputLabel>{t("city_name")}</InputLabel>
                                                    <Select
                                                    input={<OutlinedInput label={t("city_name")} />}
                                                    MenuProps={MenuProps}
                                                    value={values.city_name_location_out}
                                                    renderValue={(selected) => {
                                                        if (citiesLoading) {
                                                            return (
                                                            <div className="flex items-center gap-2">
                                                                <CircularProgress size={18} />
                                                            </div>
                                                            )
                                                        }
                                                        else {
                                                            const city = (cities as any).find((c: any) => c.id === Number(selected));
                                                            return (
                                                            <div className="flex items-center gap-2">
                                                                <span>{city?.name}</span>
                                                            </div>
                                                            );
                                                        }
                                                    }}
                                                    onChange={async (e) => {
                                                        setSelectedCity({...selectedCity,Citylocation_out:Number(e.target.value)})
                                                        setLoadingRegionOut(true);
                                                        const result = await getRegions(Number(e.target.value));
                                                        setRegionsLocation_out(result.data);
                                                        setFieldValue("city_name_location_out",e.target.value)
                                                        setFieldValue("region_name_location_out",null)
                                                        setLoadingRegionOut(false);
                                                    }}
                                                    >
                                                        {cities.map((item: any, index: number) => (
                                                            <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                                                        ))}
                                                    </Select>
                                                    {touched.city_name_location_out && errors.city_name_location_out && (
                                                        <p className="text-red-500 text-xs mt-1">
                                                            {errors.city_name_location_out as string}
                                                        </p>
                                                    )}
                                                </FormControl>
                                                {
                                                    selectedCity.Citylocation_out 
                                                    ?
                                                        <FormControl className='sm:!w-1/2 !w-full' error={touched.region_name_location_out && Boolean(errors.region_name_location_out)}>
                                                            <InputLabel>{t("region_name")}</InputLabel>
                                                            <Select
                                                            input={<OutlinedInput label={t("region_name")} />}
                                                            MenuProps={MenuProps}
                                                            value={values.region_name_location_out}
                                                            renderValue={(selected) => {
                                                                if (loadingRegionOut) {
                                                                    return (
                                                                    <div className="flex items-center gap-2">
                                                                        <CircularProgress size={18} />
                                                                    </div>
                                                                    )
                                                                }
                                                                else {
                                                                    const region = (regionsLocation_out as any).find((c: any) => c.id === Number(selected));
                                                                    return (
                                                                    <div className="flex items-center gap-2">
                                                                        <span>{region?.name}</span>
                                                                    </div>
                                                                    );
                                                                }
                                                            }}
                                                            onChange={(e) => setFieldValue("region_name_location_out",e.target.value)}
                                                            >
                                                                {regionsLocation_out.map((item: any, index: number) => (
                                                                    <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                                                                ))}
                                                            </Select>
                                                            {touched.region_name_location_out && errors.region_name_location_out && (
                                                                <p className="text-red-500 text-xs mt-1">
                                                                {errors.region_name_location_out as string}
                                                                </p>
                                                            )}
                                                        </FormControl>
                                                    :   null 
                                                }
                                            </div>
                                        </div>
                                        {/* <div>
                                            <FormControlLabel 
                                            control={
                                                <Checkbox 
                                                checked={values.with_driver}
                                                onChange={(e) => setFieldValue("with_driver", e.target.checked)}
                                                />
                                            } 
                                            label={t("i_want_the_car_with_driver")}
                                            />
                                        </div> */}
                                        <div>
                                            <p className='font-[600]'>{t("payment_method")}</p>
                                            <p className='text-[#808080] mt-2'>{t("how_do_like_to_pay")}</p>
                                            <Stack className="mt-2 mb-5" spacing={2}>
                                                <Item
                                                    onClick={() => setFieldValue("payment_type", "cash")}
                                                    sx={{
                                                    cursor: "pointer",
                                                    border: touched.payment_type && errors.payment_type 
                                                    ? "2px solid red" 
                                                    :values.payment_type === "cash"
                                                        ? "2px solid #34A835"
                                                        : "1px solid #ccc",
                                                    padding: 1,
                                                    borderRadius: 2,
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    }}
                                                >
                                                    <img className="w-[100px]" src={cash} alt="cash" />
                                                    <div>{t("cash")}</div>
                                                </Item>
                                                <Item
                                                    onClick={() => setFieldValue("payment_type", "online")}
                                                    sx={{
                                                    cursor: "pointer",
                                                    border: touched.payment_type && errors.payment_type 
                                                    ? "2px solid red" 
                                                    :values.payment_type === "online"
                                                        ? "2px solid #34A835"
                                                        : "1px solid #ccc",
                                                    padding: 1,
                                                    borderRadius: 2,
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    }}
                                                >
                                                    <img className="w-[100px]" src={online} alt="online" />
                                                    <div>{t("online")}</div>
                                                </Item>
                                                {touched.payment_type && errors.payment_type && (
                                                <div style={{ color: "red", fontSize: "12px" }}>
                                                    {errors.payment_type}
                                                </div>
                                                )}
                                            </Stack>

                                        </div>
                                        {
                                            selectedCar?.insurances?.length !== 0
                                            ?
                                                <div>
                                                    <p className='font-[600]'>{t("insurances_method")}</p>
                                                    <p className='text-[#808080] mt-2'>{t("choose_one_insurances")}</p>
                                                    <Stack className="mt-2 mb-5" spacing={2}>
                                                        {selectedCar?.insurances?.map((item: insurancesType, index: number) => (
                                                        <Item
                                                            key={index}
                                                            onClick={() => {
                                                                console.log(item.id)
                                                                setFieldValue("insurance_id", item.id)
                                                            }}
                                                            sx={{
                                                            cursor: "pointer",
                                                            border: touched.insurance_id && errors.insurance_id 
                                                            ? "2px solid red" 
                                                            :values.insurance_id === item.id
                                                                ? "2px solid #34A835"
                                                                : "1px solid #ccc",
                                                            padding: 1,
                                                            borderRadius: 2,
                                                            textAlign: "left",
                                                            }}
                                                        >
                                                            <div className='flex justify-between items-center'>
                                                                <p>{item?.type?.type}</p>
                                                                <p>{item?.price} / {t("per_day")}</p>
                                                            </div>
                                                            <p>{item?.type?.description}</p>
                                                        </Item>
                                                        ))}
                                                        {touched.insurance_id && errors.insurance_id && (
                                                        <div style={{ color: "red", fontSize: "12px" }}>
                                                            {errors.insurance_id}
                                                        </div>
                                                        )}
                                                    </Stack>
                                                </div>
                                            :
                                                <></>
                                        }
                                    </div>
                                <Button className={`w-full h-[62px] ${selectedCar?.fuel_type === "electric" ? "!bg-electricColor" : "!bg-customerColor"} !text-white !rounded-full`} type="submit">
                                {bookingLoading 
                                ? <CircularProgress className='w-1 h-1'/>
                                :t("confirm")
                                }
                                </Button>
                                </Form>
                            )}
                                </Formik>
                            </div>
                        </div>
                }
            </DialogContent>
            <UserStateDilaog
            icon={<DoNotDisturbOnIcon className='!text-red-500 !text-[60px]'/>}
            userStateDilaogDilaog={userStateDilaogDilaog}
            setUserStateDilaogDilaog={setUserStateDilaogDilaog}
            />
        </Dialog>
    )
}

export default CarDetails